import React from 'react';
import {post} from './';
import ms from 'ms';

let interval = setInterval(function () {}, 10);

export const trackingActionIntervel = () => {
  clearInterval(interval)
  trackingAction()
  interval = setInterval(function () {
    trackingAction()
  }, ms('30m'));
}

export const trackingAction = () => {
  const url = '/api/tracking-action'
  if (localStorage) {
    const lastCheck = localStorage.getItem('last-check')
    if (!lastCheck || parseInt(lastCheck) < Date.now() - ms('30m') || parseInt(lastCheck)> Date.now()) {
      let otherInf = {
          "timezone" : Intl.DateTimeFormat().resolvedOptions().timeZone,
          "userAgent" : navigator.userAgent,
          "userAgentData" : navigator.userAgentData,
          "appVersion" : navigator.appVersion,
          "systemName" : navigator.vendor,
          "platform" : navigator.platform
      }
      localStorage.setItem('last-check', Date.now())
      post(url, {otherInf})
    }
  }
}
